import { RouteComponentProps } from "@reach/router";
import React, { useEffect, useState } from "react";
import queryString from "query-string";

import Logo from "../../assets/Logo.png";
import { GuaranteeViewData } from "components/Panels/GuaranteeDataModel";
import { endpoints } from "config";
import instance from "api";
import { ApiResponse } from "@avamae/formbuilder/dist/FormBuilder";
import GuaranteePanelHeader from "components/Panels/GuaranteePanelHeader";
import { GuaranteeStatus } from "components/Panels/GuaranteesViewPanel";
import GuaranteePanelReportSummary from "components/Panels/GuaranteePanelReportSummary";
import GuaranteePanelRiskProfile from "components/Panels/GuaranteePanelRiskProfile";
import GuaranteePanelClientProfile from "components/Panels/GuaranteePanelClientProfile";
import Page from "components/Page";
import GuaranteePanelDocument from "components/Panels/GuaranteePanelDocument";
import GuaranteePanelAddressInfo from "components/Panels/GuaranteePanelAddressInfo";

type QueryParams = {
  token: string;
};

const possibleGuaranteeStatuses: GuaranteeStatus[] = [
  "approved",
  "declined",
  "locked",
  "pending",
  "released",
];

export const PdfReportPage = (props: RouteComponentProps) => {
  return (
    <Page isPublic>
      <PdfReportInnerPage {...props} />
    </Page>
  );
};

export const PdfReportInnerPage = (props: RouteComponentProps) => {
  const [details, setDetails] = useState<GuaranteeViewData | null>(null);
  const [loading, setLoading] = useState(true);
  const location = window.location;
  const queryParams = queryString.parse(location.search, {
    decode: false,
  });

  useEffect(() => {
    if (!queryParams.token) return setLoading(false);
    instance
      .post<ApiResponse<GuaranteeViewData>>(endpoints.external.reportData, {
        // using post because the backend wants the token in body
        token: queryParams.token,
      })
      .then(res => setDetails(res.data.details))
      .catch(err => null) //TODO error handling
      .finally(() => {
        setLoading(false);
      });
  }, [queryParams.token]);
  if (loading) return null;
  if (details !== null) {
    return (
      <div className="PdfReportPage">
        <div className="ReportSection">
          <GuaranteePanelHeader details={details} report={true} />
        </div>
        <div className="ReportSection">
          <GuaranteePanelReportSummary details={details} report={true} />
        </div>
        <div className="ReportSection">
          <GuaranteePanelRiskProfile details={details} report={true} />
        </div>
        <div className="ReportSection">
          <GuaranteePanelClientProfile details={details} report={true} />
        </div>
        <div className="ReportSection">
          <GuaranteePanelDocument details={details} report={true} />
        </div>
        <div className="ReportSection">
          <GuaranteePanelAddressInfo details={details} report={true} />
        </div>
      </div>
    );
  }
  return <div className="CenteredError">Error Loading transaction</div>;
};
